// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { OrdersPanel } from '../OrdersPanel';
export class OptionOrdersPanel extends OrdersPanel {
    constructor() {
        super();
        this.isFiltered = true;
        this.Name = 'OptionOrdersPanel';
        this.headerLocaleKey = 'panel.optionOrders';
        this.AddOrderEvent = this.AddOrderEvent.bind(this);
        this.RemoveOrderEvent = this.RemoveOrderEvent.bind(this);
        this.populateItemsDirect = this.populateItemsDirect.bind(this);
    }
    oninit() {
        void super.set('isRelativeStyle', true);
        void super.set('isAllowPadding', false);
        super.observe('visible', this.onVisibleChanged);
    }
    getType() {
        return PanelNames.OptionOrdersPanel;
    }
    TickAsync() {
        super.TickAsync();
        const isVisible = this.get('visible');
        if (!isVisible) {
            return;
        }
        this.getQuickTable().needRedrawBackground = true;
    }
    populateItemsDirect() {
        const quickTable = this.getQuickTable();
        quickTable.ClearAll();
    }
    setOptionTrader(optionTrader) {
        this._optionTrader = optionTrader;
        this.DCEventsSubscribe();
    }
    DCEventsSubscribe() {
        if (isNullOrUndefined(this._optionTrader)) {
            return;
        }
        this._optionTrader.subscribeOnRepopulate(this.populateItemsDirect);
        this._optionTrader.subscribeOnAddOrder(this.AddOrderEvent);
        this._optionTrader.subscribeOnRemoveOrder(this.RemoveOrderEvent);
    }
    DCEventsUnSubscribe() {
        if (isNullOrUndefined(this._optionTrader)) {
            return;
        }
        this._optionTrader.unsubscribeOnRepopulate(this.populateItemsDirect);
        this._optionTrader.unsubscribeOnAddOrder(this.AddOrderEvent);
        this._optionTrader.unsubscribeOnAddOrder(this.RemoveOrderEvent);
    }
    callThemeChange() {
        this.themeChange();
    }
    callCallback(properties) {
        this.callBack(properties);
    }
    onVisibleChanged() {
        this.layoutTable();
    }
}
